import React from "react";
import Typewriter from "typewriter-effect";
import "./Badge.css";

const services = [
  "Google Ads",
  "Social Media Ads (Facebook/Instagram)",
  "Social Media Optimization (SMO)",
  "Social Media Management (SMM)",
  "Search Engine Optimization (SEO) ",
  "Website Design & Development",
];

const TypewriterBadge = () => {
  // We no longer need useState, useEffect, or containerRef for width logic
  return (
    // The main badge container now uses the CSS fix
    <div className="typewriter-badge">
      <span className="constant-text">5+ YEARS OF&nbsp;</span>
      
      {/* The dynamic-text wrapper is the key. 
        It MUST be separated from the constant text.
      */}
      <span className="dynamic-text-wrapper">
        <Typewriter
          options={{
            strings: services,
            autoStart: true,
            loop: true,
            delay: 80,
            deleteSpeed: 40,
            pauseFor: 1500,
          }}
          // Removed onStringTyped
        />
      </span>
    </div>
  );
};

export default TypewriterBadge;